import api from "../../utils/axios";

export async function listMarketplaceProducts(clubId, params = {}) {
  const { data } = await api.get(`/v1/clubs/${clubId}/marketplace/products`, {
    params,
  });
  return data;
}

export async function getMarketplaceProduct(clubId, productId) {
  const { data } = await api.get(
    `/v1/clubs/${clubId}/marketplace/products/${productId}`,
  );
  return data;
}

export async function createMarketplaceProduct(clubId, payload) {
  const { data } = await api.post(
    `/v1/clubs/${clubId}/marketplace/products`,
    payload,
  );
  return data;
}

export async function updateMarketplaceProduct(clubId, productId, payload) {
  const { data } = await api.patch(
    `/v1/clubs/${clubId}/marketplace/products/${productId}`,
    payload,
  );
  return data;
}

export async function deleteMarketplaceProduct(clubId, productId) {
  const { data } = await api.delete(
    `/v1/clubs/${clubId}/marketplace/products/${productId}`,
  );
  return data;
}
